import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';

import contributionComponent from './contributionComponent';
import controller from './assessment-factor.controller';
import directive from './assessment-factor.directive';

export default angular.module('app.components.advisory.ecat.assessmentFactor', [
  alerts,
  ecatDataService,
  ecatSharedModelService,
  confirmDialog,
  constants,
  docDataService,
  loaderService,
  orgDataService,
  ssDialogService,
  userService,
  contributionComponent,
])
  .directive('ecatAssessmentFactor', directive)
  .controller('AssessmentFactorController', controller)
  .name;

console.log('app.components.advisory.ecat.assessmentFactor created');
